import { render, staticRenderFns } from "./RaceAlert.vue?vue&type=template&id=447faf00"
import script from "./RaceAlert.vue?vue&type=script&lang=js"
export * from "./RaceAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports